import { useEffect } from "react";

/** Setzt Seitentitel & Meta-Description pro Route (SEO-Basics) */
export default function SEO({ title, description }) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
  return null;
}
